export function getAccessToken() {
  const parsedPersistedStorage = JSON.parse(
    localStorage.getItem("persist:root")
  );
  if ([undefined, null, ""].includes(parsedPersistedStorage?.currentUser)) {
    return null;
  }
  const persistedCurrentUserString = parsedPersistedStorage.currentUser;
  const persistedCurrentUser = JSON.parse(persistedCurrentUserString);
  return persistedCurrentUser.accessToken;
}

export function getUserId() {
  const parsedPersistedStorage = JSON.parse(
    localStorage.getItem("persist:root")
  );
  if (![undefined, null, ""].includes(parsedPersistedStorage?.currentUser)) {
    const persistedCurrentUserString = parsedPersistedStorage.currentUser;
    const persistedCurrentUser = JSON.parse(persistedCurrentUserString);
    if (persistedCurrentUser.user) {
      return persistedCurrentUser.user.id;
    }
  }
  return null;
}
